import Reveal, { SectionHead } from "@/components/Reveal";

const STEPS = [
    {
        n: "01",
        title: "Export your statement CSV",
        desc: "Download a statement export from your bank's app or netbanking portal — the same file you already get today.",
    },
    {
        n: "02",
        title: "Import it into fynary.",
        desc: "Tap to choose the CSV — up to 5 MB, .csv only. fynary reads your transactions and builds your month.",
    },
    {
        n: "03",
        title: "Ask fynary where it went",
        desc: "Get your monthly snapshot, six-month trends and a spending assistant that answers from your own data.",
    },
];

export default function HowItWorks() {
    return (
        <section id="how-it-works" className="scroll-mt-24 border-t border-white/5 py-20 sm:py-24 lg:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
                <SectionHead
                    eyebrow="How it works"
                    title="Statement to clarity in three steps."
                    sub="No account linking, no credentials. You stay in control of what fynary. sees."
                    testid="how-it-works-heading"
                />

                <div className="mt-12 grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-3">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={0.06 * i}>
                            <div
                                data-testid={`how-it-works-step-${i + 1}`}
                                className="group h-full rounded-[24px] border border-white/10 bg-fynary-surface p-6 transition-[border-color] duration-200 hover:border-fynary-lime/40 sm:p-8"
                            >
                                <div className="flex items-baseline justify-between">
                                    <span className="font-display text-5xl font-extrabold text-white/10 transition-[color] duration-300 group-hover:text-fynary-lime/25">
                                        {s.n}
                                    </span>
                                    <span className="h-2 w-2 rounded-full bg-fynary-lime" />
                                </div>
                                <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white sm:text-xl">{s.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-fynary-muted sm:text-base">{s.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
